import {
   Cluster as ClusterType,
   useClusteredDataContext,
} from 'Guide/Schematics/Diagram/Providers/clusteredData';
import { iFixitHotSpotItem } from './iFixitHotSpotItem';
import { BasicCluster } from 'Guide/Schematics/Diagram/Generic/basicCluster';
import { useToken } from '@chakra-ui/react';
import { KeyboardEventHandler, memo, useContext } from 'react';
import { ZoomContext } from 'Guide/Schematics/Diagram/Providers/d3Zoomable';

const MemoBasicCluster = memo(BasicCluster);

export function Cluster({ cluster }: { cluster: ClusterType<iFixitHotSpotItem> }) {
   const x = average(cluster.map(p => p.x));
   // @ts-expect-error TS(2345) FIXME: Argument of type '(number | undefined)[]' is not a... Remove this comment to see the full error message
   const scaledX = average(cluster.map(p => p.scaledX));
   const y = average(cluster.map(p => p.y));
   // @ts-expect-error TS(2345) FIXME: Argument of type '(number | undefined)[]' is not a... Remove this comment to see the full error message
   const scaledY = average(cluster.map(p => p.scaledY));
   // @ts-expect-error TS(2345) FIXME: Argument of type 'number | undefined' is not assig... Remove this comment to see the full error message
   const tabIndex = Math.max(...cluster.map(p => p.tabIndex));

   const [clusterInner, clusterOuter] = useToken('colors', ['clusterInner', 'clusterOuter']);

   const clusteredDataContext = useClusteredDataContext<iFixitHotSpotItem>();
   const zoomContext = useContext(ZoomContext);

   const onClick = () => {
      const isSmallCluster = cluster.length <= 3;

      const zoomFactor = isSmallCluster
         ? clusteredDataContext.getFullDeclusterZoomFactor(cluster)
         : clusteredDataContext.getDeclusterZoomFactor(cluster);

      const newZoomFactor = zoomContext.d3Transform.k * zoomFactor;
      const newX = x * newZoomFactor;
      const newY = y * newZoomFactor;

      zoomContext.scaleAndCenterOn(newX, newY, newZoomFactor);
   };

   const onKeyDown: KeyboardEventHandler<SVGGElement> = event => {
      if (event.key === 'Enter') {
         onClick();
      }
   };

   return (
      <MemoBasicCluster
         scaledX={scaledX}
         scaledY={scaledY}
         text={cluster.length.toString()}
         outerCircleProps={{
            fill: clusterOuter,
            _groupHover: {
               fill: clusterInner,
            },
            _groupFocus: {
               fill: clusterInner,
            },
         }}
         innerCircleProps={{
            fill: clusterInner,
            _groupHover: {
               fill: clusterOuter,
            },
            _groupFocus: {
               fill: clusterOuter,
            },
         }}
         textProps={{
            dy: '0.35em',
            fill: clusterOuter,
            _groupHover: {
               fill: 'white',
            },
            _groupFocus: {
               fill: 'white',
            },
            fontSize: '14px',
            fontWeight: '600',
         }}
         groupProps={{
            focusable: true,
            cursor: 'pointer',
            _focus: {
               outline: 'none',
            },
            role: 'group',
            tabIndex: tabIndex,
            onClick: onClick,
            onKeyDown: onKeyDown,
         }}
      />
   );
}

const average = (numbers: number[]) => sum(numbers) / (numbers.length || 1);

const sum = (numbers: number[]) => numbers.reduce((a, b) => a + b, 0);
